<template>
	<div>
		<van-tabbar v-model="active_">
			<!-- <van-tabbar-item icon="wap-home-o">首页</van-tabbar-item>-->
			<van-tabbar-item icon="notes-o" @click="go('MeetingList')">会议中心</van-tabbar-item>
			<van-tabbar-item icon="user-o" @click="go('SignUpmeetingCenter')">报名会议</van-tabbar-item>
			<van-tabbar-item icon="coupon" @click="go('meetingPapers')">论文列表</van-tabbar-item>
			<van-tabbar-item icon="coupon" @click="go('meetPaymentList')">缴费列表</van-tabbar-item>
			<!-- 
			<van-tabbar-item icon="setting-o" @click="go('invoiceHome')">发票管理</van-tabbar-item> -->
		</van-tabbar>
	</div>
</template>
<script>
	import {
		logout,
		getCurrentAccount,
		getLastLoginTime,

	} from "@/api/dictionary";
	import { getSessionStore } from "@/utils/sessionStorage";
	import { NavBar, Icon, Row, Col, DropdownMenu, DropdownItem, Dialog, Tabbar, TabbarItem } from 'vant';

	export default {
		props: ["title", "active"],
		data() {
			return {
				lastLoginTime: "",
				// active:1,
			};
		},
		components: {
			[NavBar.name]: NavBar,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[DropdownMenu.name]: DropdownMenu,
			[DropdownItem.name]: DropdownItem,
			[Dialog.name]: Dialog,
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
		},

		methods: {
			go(pathName) {
				this.$router.push({ name: pathName });
			}
		},
		computed: {
			active_: {
				get() {
					return this.active;
				},
				set(val) {
					this.$emit("on_chang_active", val)
				}
			}
		},
		mounted() {
			// this.getUserInfo();
			// this.getLastLoginTime();
		}
	};
</script>

<style lang="less" scoped>
	.van-tabbar--fixed {
		border-top: #efefef solid 1px;
	}
</style>